<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import * as echarts from 'echarts'

const props = withDefaults(defineProps<{
  option: echarts.EChartsOption
  height?: string
  ariaLabel?: string
}>(), { height: '220px', ariaLabel: '数据图表' })

const element = ref<HTMLDivElement | null>(null)
let chart: echarts.ECharts | null = null
let observer: ResizeObserver | null = null

function render(): void {
  if (!element.value) return
  if (!chart) chart = echarts.init(element.value, undefined, { renderer: 'canvas' })
  chart.setOption(props.option, true)
}

onMounted(() => {
  render()
  observer = new ResizeObserver(() => chart?.resize())
  if (element.value) observer.observe(element.value)
})

watch(() => props.option, render, { deep: true })

onBeforeUnmount(() => {
  observer?.disconnect()
  chart?.dispose()
  chart = null
})
</script>

<template>
  <div
    ref="element"
    class="chart-box"
    :style="{ height }"
    role="img"
    :aria-label="ariaLabel"
  />
</template>
